import { Navigate, Outlet } from "react-router-dom";
import {
  consumePostLoginRedirect,
  isSafePostLoginPath,
  peekPostLoginRedirect,
} from "../utils/postLoginRedirect";

function Auth({ user, location }) {
  const hasSession =
    sessionStorage.getItem("_t") || localStorage.getItem("_t");

  if (user && hasSession && !location?.state?.gotoJobBoard) {
    const returnTo =
      (location.state?.from && isSafePostLoginPath(location.state.from)
        ? location.state.from
        : null) || peekPostLoginRedirect();
    if (returnTo) {
      consumePostLoginRedirect();
      return <Navigate to={returnTo} replace />;
    }
    return (
      <Navigate
        to={user.phoneNumber ? "/dashboard" : "/my-profile"}
        replace
      />
    );
  }

  return <Outlet />;
}
export default Auth;
